module.exports = __webpack_public_path__ + "static/media/Expand_More_Icon.f79d8982.svg";